import React from "react";

import { ReactComponent as ProvArrowSVG } from "../../../assets/provArrow.svg";
import { ReactComponent as ProvEqSVG } from "../../../assets/provEq.svg";
import { ReactComponent as ProvPlusSVG } from "../../../assets/provPlus.svg";
import {
  DetailedContainer,
  DetailedDescription,
  Row,
  Column,
  Box,
  // Romb,
  Circle,
  Line
} from "./ProvFairStyled";
export default () => {
  return (
    <DetailedContainer>
      <DetailedDescription>
        <h4>Before Game</h4>
        <p>
          You will get an encrypted Hash of the Serverseed before you start
          gambling. Sinceyou get it in advance, the site cannot change it later.
          However, it is encrypted, so you cannot calculate your own state
          results in advance (only afterwards if you get the Unhashed
          Serverseed.)
        </p>
      </DetailedDescription>
      <Row>
        <h4>user</h4>
        <h4>server</h4>
      </Row>
      <Row>
        <Column>
          <Box>
            Seed
            <Circle className="rightCorner" />
            <Line className="diagBotLong" />
          </Box>
          <Box className="round">Seed</Box>
          <Box className="round">
            Hash Seed
            <Circle />
            <Line className="diagTop" />
          </Box>
        </Column>
        <Column>
          <Box className="round">
            Seed
            <Circle className="bottom" />
            <Line className="down" />
          </Box>
          <Box className="round">
            Hash Seed
            <Circle className="left" />
            <Circle className="top" />
          </Box>
          <Box>
            Seed
            <Circle className="leftCorner" />
          </Box>
        </Column>
      </Row>
      <DetailedDescription>
        <h4>Game</h4>
        <p>
          Your browser will generate a random Clientseed. However, you could and
          should adjust this Clientseed before you start. This way you can make
          sure the site does not know your Clientseed before start game and
          server already send you the encrypted Hash of the Serverseed, so
          server cannot change it after getting Clientseed.
        </p>
      </DetailedDescription>
      <Row>
        <h4>user</h4>
        <h4>server</h4>
      </Row>
      <Row>
        <Column>
          <Box>Seed</Box>
          <Box>
            Outcome
            <Circle />
            <Line />
          </Box>
        </Column>
        <Column>
          <Box>Seed</Box>
          <ProvPlusSVG />
          <Box className="round">Hash Seed</Box>
          <ProvPlusSVG />
          <Box className="round">
            Nonce 3<ProvArrowSVG />
          </Box>
          <ProvEqSVG />
          <Box>
            Outcome
            <Circle className="left" />
          </Box>
        </Column>
      </Row>
      <DetailedDescription>
        <h4>After Game</h4>
        <p>
          Now if you make a bet the Nonce starts with 0 or 1. After each bet you
          make, the Nonce number will go up by 1
        </p>
      </DetailedDescription>
      <Row>
        <h4>user</h4>
        <h4>server</h4>
      </Row>
      <Row>
        <Column className="border-b">
          <Box className="round">
            Seed
            <Circle />
            <Line className="diagBot" />
          </Box>
          <Box className="round">
            Hash Seed
            <Circle />
            <Line className="diagTop" />
          </Box>
        </Column>
        <Column className="border-b centered">
          <Box className="round">
            Seed
            <Circle className="left" />
          </Box>
        </Column>
      </Row>
    </DetailedContainer>
  );
};
